import { render } from "./ProfilePanel.vue?vue&type=template&id=0ed6d4a5&ts=true"
import script from "./ProfilePanel.vue?vue&type=script&lang=ts"
export * from "./ProfilePanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__